import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { usePayable, Payable } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<Payable>
      useData={usePayable}
      config={{
        ...moduleConfig,
        getDetailSections: (item) =>
          getDetailSections(item, moduleConfig.utils.formatDate, moduleConfig.utils.formatCurrency),
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
